import { render, staticRenderFns } from "./DsVideoRank.vue?vue&type=template&id=4938ce71&scoped=true"
import script from "./DsVideoRank.vue?vue&type=script&lang=js"
export * from "./DsVideoRank.vue?vue&type=script&lang=js"
import style0 from "./DsVideoRank.vue?vue&type=style&index=0&id=4938ce71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4938ce71",
  null
  
)

export default component.exports